export enum SmoMoonType {
  single = 'single',
  story = 'story',
  multi = 'multi'
}

export const allSmoMoonTypes: SmoMoonType[] = Object.values(SmoMoonType);
